(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda-day
    module.directive('agendaDayPart', [function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-day-part.template.html',
            controller: 'AgendaDayPartController',
            controllerAs: 'vm',
            scope: {
                part: '=',
                useDayParts: '='
            },
            bindToController: true           
        };
        return directive;
       
      
    }]);

})();